<template>

  <div
    v-if="letter.id"
  >
    <div
      class="row"
    >
      <div class="col-md-12">
        <b-card
          no-body
        >
          <div class="m-2">
            <div class="row">
              <div class="col-6">
                <table class="mt-2 mt-xl-0 w-100">
                  <tr>
                    <th>{{ $t('Code') }}</th>
                    <td> {{ letter.code }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t('From') }}</th>
                    <td> {{ $langName(letter.from_org.name) }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t('To') }}</th>
                    <td> {{ letter.to_org.name[$i18n.locale] }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t('Short Info') }}</th>
                    <td> {{ letter.short_info }}</td>
                  </tr>
                </table>
              </div>
              <div class="col-6">
                <table class="mt-2 mt-xl-0 w-100">
                  <tr>
                    <th>{{ $t('Status') }}</th>
                    <td>
                      <b-badge :variant="getLetterStatusColor(letter.letter_status)">
                        {{ $langName(getLetterStatus(letter.letter_status).name) }}
                      </b-badge>
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t('Letter Type') }}</th>
                    <td> {{ getLetterType(letter.letter_type).name[$i18n.locale] }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t('Period') }}</th>
                    <td> {{ letter.period.name }}</td>
                  </tr>
                  <tr>
                    <th>{{ $t('Rejected Info') }}</th>
                    <td> {{ letter.reject_info }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <l-table
      ref="LTable"
      :module-name="MODULE_NAME"
      :table-columns="tableColumns"
      :filter-class="filterClass"
      :table-config-options="{ endpoint: 'letter/history'}"
    >
      <template #create-body>
        <create
          ref="createLetter"
          @refetchData="refetchData"
        />
      </template>
      <template #cell(period)="{ data }">
        {{ data.value.name }}
      </template>

      <template #cell(to_org)="{ data }">
        {{ $langName(data.value.name) }}
      </template>

      <template #cell(letter_status)="{ data }">
        <b-badge :variant="getLetterStatusColor(data.value)">
          {{ $langName(getLetterStatus(data.value).name) }}
        </b-badge>
      </template>

      <template #cell(letter_type)="{ data }">
        {{ $langName(getLetterType(data.value).name) }}
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="{ data }">

        <div class="text-nowrap">
          <feather-icon
            v-b-toggle.sidebar-create-letter
            icon="EyeIcon"
            class="cursor-pointer mr-1"
            size="16"
            @click="$router.push({ name: 'letter-view', params: { id: data.item.id }})"
          />
          <feather-icon
            v-if="canUpdate(data.item)"
            v-b-toggle.sidebar-create-letter
            icon="EditIcon"
            class="cursor-pointer mr-1"
            size="16"
            @click="update(data.item)"
          />
          <feather-icon
            v-if="canDelete(data.item)"
            icon="TrashIcon"
            class="cursor-pointer mr-1"
            size="16"
            @click="remove(data.item)"
          />
        </div>
      </template>
    </l-table>
  </div>

  <!-- Table Container Card -->

</template>

<script>
import {
  BCard, VBToggle, BBadge,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import config from './config'
import letterModule from '@/store/letter/index'
import permission from './permission'
import LTable from '@/views/components/LTable.vue'
import Letter from '@/views/components/filters/service/Letter'
import Create from '@/views/pages/letter/Create.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    Create,
    LTable,
    BCard,
    BBadge,
  },
  computed: {
    letter() {
      return this.$store.state[this.MODULE_NAME].history_letter
    },
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.$store.commit('letter/FRESH_HISTORY')
      this.$store.dispatch('staticModule/letterTypes')
      this.$store.dispatch('staticModule/letterStatuses')
      this.$store.dispatch('staticModule/periodList')
      this.$store.dispatch('staticModule/organizationList')
      this.$store.dispatch(`${this.MODULE_NAME}/get`, this.$route.params.id).then(res => {
        this.$store.commit('letter/HISTORY_LETTER', res.data)
      })
    },
    getLetterType(id) {
      return this.$store.getters['staticModule/getLetterType'](id)
    },
    getLetterStatus(id) {
      return this.$store.getters['staticModule/getLetterStatus'](id)
    },
    getLetterStatusColor(id) {
      return this.$store.getters['staticModule/getLetterStatusColor'](id)
    },
    update(data) {
      this.$store.commit(`${this.MODULE_NAME}/UPDATE`, data)
    },
    created() {
      this.$store.commit(`${this.MODULE_NAME}/FRESH`, this.$store.state.staticModule.letterTypeSimple)
    },
    targeted() {
      this.$store.commit(`${this.MODULE_NAME}/FRESH`, this.$store.state.staticModule.letterTypeTargeted)
    },
    remove(data) {
      this.$removeSwal(this, data, `${this.MODULE_NAME}/del`, this.refetchData)
    },
    refetchData() {
      this.$refs.LTable.refetchData()
    },
  },
  setup() {
    const MODULE_NAME = 'letter'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, letterModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })
    const filterClass = new Letter()

    return {
      filterClass,
      MODULE_NAME,
      ...permission(),
      ...config(),
    }
  },
}
</script>
